module.exports = __webpack_public_path__ + "img/ss.5831c975.svg";